import { push } from 'connected-react-router';

export function redirect(route) {
	return (dispatch) => {
		if (!route.includes('/login')) {
			// eslint-disable-next-line no-undef
			sessionStorage.setItem('currentWorkingRoute', route);
		}
		dispatch(push(route));
	};
}
